import React from 'react';
import styles from './index.modules.scss';
import { Icon } from '@shakkerai/components';
import { Text } from '@shakkerai/pro-components';

export const NavBar = (props) => {
  const { title, onBack, onClose, children, iconClass, leftSection } = props;
  return (
    <div className={styles.nav}>
      <div className={styles.leftSection}>
        {leftSection ? (
          leftSection()
        ) : (
          <>
            {iconClass ? (
              <Icon className={`${iconClass} mr-1`} fontSize={14} color={'var(--color-primary-font)'} />
            ) : (
              <Icon
                className={`icon-border_left ${styles.icon} mr-1`}
                onClick={onBack}
                fontSize={14}
                color={'var(--color-primary-font)'}
              />
            )}

            <Text fw={500} size={14} color="var(--color-primary-font)">
              {title}
            </Text>
          </>
        )}
      </div>

      <div className={styles.rightSection}>
        {children}
        <Icon
          className={`icon-border_close-1 ${styles.icon}  ml-1`}
          onClick={onClose}
          fontSize={16}
          color={'var(--color-subsidiary-font)'}
        />
      </div>
    </div>
  );
};
